import * as types from '@/store/types';
import { removeNamespaces } from '@/helpers/utils';

const localTypes = removeNamespaces(types);

export default {
  [localTypes.INFO_MESSAGES_SET](state, payload) {
    state.infoMessages = payload;
  },
};
